module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMi4xMTVMMi4xMTUgMEwxMC41IDguMzg1TDE4Ljg4NSAwTDIxIDIuMTE1TDEyLjYxNSAxMC41TDIxIDE4Ljg4NUwxOC44ODUgMjFMMTAuNSAxMi42MTVMMi4xMTUgMjFMMCAxOC44ODVMOC4zODUgMTAuNUwwIDIuMTE1WiIgZmlsbD0iI2NjY2NjYyIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homebase/modal_icon_close.svg
// module id = /vfa
// module chunks = 1